import {Component, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {ConstatService} from "../../../services/constat.service";
import {UserService} from "../../../services/user.service";
import {Residency} from "../../../shared/interfaces/Residency";
import {SharedService} from "../../../services/shared.service";
import {Constat} from "../../../shared/interfaces/Constat";
import {IndexedDbService} from "../../../services/indexed-db.service";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {SpinnerComponent} from "../../../shared/components/spinner/spinner.component";
import {MatFormField, MatLabel} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-residency-choice',
  templateUrl: './residency-choice.component.html',
  styleUrl: './residency-choice.component.css',
  encapsulation: ViewEncapsulation.None,
  imports: [
    SpinnerComponent,
    MatLabel,
    MatSelect,
    MatOption,
    MatFormField,
    FormsModule
  ],
  standalone: true
})
export class ResidencyChoiceComponent implements OnInit {
  residencyList: Residency[];
  constat: Constat;
  fullname: string;
  selectedResidency!: Residency;
  residencyToSetInIndexDB!: Constat;


  constructor(private constatService: ConstatService,
              private userService: UserService,
              private sharedService: SharedService,
              private dexieDBService: IndexedDbService,
              private toastr: ToastrService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.getAllConstats()
  }

  getAllConstats(): void {
    this.constatService.getAllConstats().subscribe((constats) => {
      this.constat = constats;
      this.userService.completeUserInIndexedDB(constats.user).then(async r => {
        this.fullname = await this.userService.getUserFullname() as string;
        this.sharedService.isUserLoad(true)
      });
      this.residencyList = constats.residences
    })
  }

  onChangeResidency() {
    this.extractConstatsFromResidency(this.selectedResidency)
  }

  async onClickExit() {
    let selectedResidency = await this.dexieDBService.getAllDatasFromIndexDb('selectedResidency')
    if (selectedResidency?.length === 0) {
      this.toastr.error('Veuillez sélectionner une résidence')
    } else {
      this.router.navigate(['/'])
    }
  }

  async onClickSyncroniser() {
    await this.dexieDBService.removeDataFromTable('selectedResidency');
    await this.dexieDBService.removeDataFromTable('fullConstats')
    await this.dexieDBService.selectedResidency.put(this.residencyToSetInIndexDB);
    this.router.navigate(['/']);
  }


  extractConstatsFromResidency(residency: Residency) {
    const localsLinkedToResidency = this.constat.locaux.filter(local => local.idResidence === residency.id);
    const idLocals: string[] = localsLinkedToResidency.map((local => local.id));
    const constatsLinkedToIdlocals = this.constat.constats.filter(constat => idLocals.includes(constat.idLocal));
    this.residencyToSetInIndexDB = {
      selectedResidency: 'selectedResidency',
      constats: constatsLinkedToIdlocals,
      locaux: localsLinkedToResidency,
      residences: [residency],
      // @ts-ignore
      user: null
    }
    this.residencyToSetInIndexDB.constats = constatsLinkedToIdlocals;
    this.residencyToSetInIndexDB.locaux = localsLinkedToResidency;
    this.residencyToSetInIndexDB.residences = [residency];
  }
}
